import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';

import {AppComponent} from './app.component';
import {CalculatorComponent} from './components/calculator/calculator.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {TcoComponent} from './components/tco/tco.component';
import {HeaderComponent} from './components/header/header.component';
import {MatToolbarModule} from '@angular/material/toolbar';
import { FooterComponent } from './components/footer/footer.component';
import { HomeComponent } from './components/home/home.component';
import { AssumptionsComponent } from './components/assumptions/assumptions.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { ResultsComponent } from './components/results/results.component';
import { TcoResultsComponent } from './components/tco-results/tco-results.component';
import {MatTabsModule} from '@angular/material/tabs';
import { TruckSelectComponent } from './components/truck-select/truck-select.component';
import { FaqComponent } from './components/faq/faq.component';
import { HomeContentBoxComponent } from './components/home-content-box/home-content-box.component';
import { AboutComponent } from './components/about/about.component';
import { CalculatorIntroComponent } from './components/calculator-intro/calculator-intro.component';
import { CalcIntroContentBoxComponent } from './components/calc-intro-content-box/calc-intro-content-box.component';
import { FaqEntryComponent } from './components/faq-entry/faq-entry.component';
import { CalculatorProcessComponent } from './components/calculator-process/calculator-process.component';
import { TruckInputComponent } from './components/truck-input/truck-input.component';
import {PdfMakeWrapper} from 'pdfmake-wrapper';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { TruckSelection } from './pipes/truck-selection.pipe';
import { TcoValuesPipe } from './pipes/tco-values.pipe';
import { ToFixedPipe } from './pipes/to-fixed.pipe';
import { ContactComponent } from './components/contact/contact.component';
import { SanitizeHtmlPipe } from './pipes/sanitize-html.pipe';


@NgModule({
  declarations: [
    AppComponent,
    CalculatorComponent,
    TcoComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    AssumptionsComponent,
    ProgressBarComponent,
    ResultsComponent,
    TcoResultsComponent,
    TruckSelectComponent,
    FaqComponent,
    HomeContentBoxComponent,
    AboutComponent,
    CalculatorIntroComponent,
    CalcIntroContentBoxComponent,
    FaqEntryComponent,
    CalculatorProcessComponent,
    TruckInputComponent,
    TruckSelection,
    TcoValuesPipe,
    ToFixedPipe,
    ContactComponent,
    SanitizeHtmlPipe
  ],
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        MatCheckboxModule,
        MatToolbarModule,
        AppRoutingModule,
        MatTabsModule
    ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}

PdfMakeWrapper.setFonts(pdfFonts);
